import {  Container, Typography } from "@mui/material";
import Layout from "../components/layout/LandingPageLayout";

const Terms = () => {
  return (
    <Layout>
    <Container sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>
        Terms & Conditions
      </Typography>
      <Typography paragraph>
        Welcome to F-AI. By accessing or using our website and services, you
        agree to comply with and be bound by the following terms and conditions.
      </Typography>
      <Typography paragraph>
        - You agree to use our services for lawful purposes only. <br />
        - We reserve the right to update or modify these terms at any time. <br />
        - Payments made via Razorpay are subject to their terms of service.
      </Typography>
    </Container>
    </Layout>
  );
};

export default Terms;
